<template>
  <TagLink
    :tag="tagLink.tag"
    :attr-tag="tagLink.attrTag"
    class="flex items-center text-gray-medium hover:text-blue-primary transition-colors"
  >
    <AppIcon
      :name="icon.name"
      :viewBox="icon.viewBox"
      :size="icon.size"
    />
    <span class="text__sub--1 mr-2">
      {{ text }}
    </span>
  </TagLink>
</template>

<script>
import AppIcon from '@library/element/icon'

export default {
  name: 'AvatarItem',
  components: { AppIcon },
  props: {
    text: {
      type: String,
      default: ''
    },
    tagLink: {
      type: Object,
      default: () => ({})
    },
    icon: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
